// tslint:disable:no-shadowed-variable

import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { database } from 'firebase';
import { FirebaseObject } from './firebase-object';

export class FirebaseService<T extends FirebaseObject> {
  list: FirebaseListObservable<T[]>;

  constructor(protected db: AngularFireDatabase, private url: string) {
    this.list = db.list(url);
  }

  get $ref() {
    return this.list.$ref;
  }

  readChild(key: string, parentKey?: string): FirebaseObjectObservable<T> {
    const list = parentKey ? `${this.url}/${parentKey}` : this.url;
    return this.db.object(`${list}/${key}`);
  }

  readChildAsList(key: string, options?): FirebaseListObservable<T[]> {
    return this.db.list(`${this.url}/${key}`, options);
  }

  attachField<T>(listObservable: FirebaseListObservable<T[]>, field: string, newField: string): FirebaseListObservable<T[]> {
    return listObservable.map(list => list.map(item => this.readField(item, field, newField))) as FirebaseListObservable<T[]>;
  }

  readField<T>(object: T, field: string, newField: string): T {
    object[newField] = this.readChild(object[field]);
    return object;
  }

  pushObject(list: FirebaseListObservable<T[]> | database.Reference, value: T): database.ThenableReference {
    return list.push(value);
  }

  push(value: T) {
    return this.list.push(value);
  }

  update(key: string, value: T) {
    return this.list.update(key, value);
  }

  remove(key: string) {
    return this.list.remove(key);
  }

  get timestamp(): Object {
    return database.ServerValue.TIMESTAMP;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/firebase/firebase-service.ts